import * as types from "../types/index";
import { core } from "./core";

export const getSickLeaveList = (queryString) => {
  return core.API(
    "GET",
    `/sick-leaves?${queryString}`,
    types.GET_SICK_LEAVES,
    types.GET_SICK_LEAVES_SUCCESS,
    types.GET_SICK_LEAVES_FAILURE
  );
};

export const createSickLeave = (data) => {
  return core.API(
    "POST",
    `/sick-leave`,
    types.CREATE_SICK_LEAVE,
    types.CREATE_SICK_LEAVE_SUCCESS,
    types.CREATE_SICK_LEAVE_FAILURE,
    data
  );
};

export const deleteSickLeave = (id) => {
  return core.API(
    "DELETE",
    `/sick-leave/${id}`,
    types.DELETE_SICK_LEAVE,
    types.DELETE_SICK_LEAVE_SUCCESS,
    types.DELETE_SICK_LEAVE_FAILURE
  );
};

export const updateSickLeave = (id, data) => {
  return core.API(
    "PUT",
    `/sick-leave/${id}`,
    types.PUT_SICK_LEAVE,
    types.PUT_SICK_LEAVE_SUCCESS,
    types.PUT_SICK_LEAVE_FAILURE,
    data
  );
};

export const getSickLeaveUsers = (id, queryString) => {
  return core.API(
    "GET",
    `/sick-leave/${id}/users?${queryString}`,
    types.GET_SICK_LEAVE_USERS,
    types.GET_SICK_LEAVE_USERS_SUCCESS,
    types.GET_SICK_LEAVE_USERS_FAILURE
  );
};

export const addSickLeaveUser = (id, data) => {
  return core.API(
    "POST",
    `/sick-leave/${id}/user`,
    types.ADD_SICK_LEAVE_USER,
    types.ADD_SICK_LEAVE_USER_SUCCESS,
    types.ADD_SICK_LEAVE_USER_FAILURE,
    data
  );
};

export const updateSickLeaveUser = (sick_leave_id, user_id, data) => {
  return core.API(
    "PUT",
    `/sick-leave/${sick_leave_id}/user/${user_id}`,
    types.PUT_SICK_LEAVE_USER,
    types.PUT_SICK_LEAVE_USER_SUCCESS,
    types.PUT_SICK_LEAVE_USER_FAILURE,
    data
  );
};

export const deleteSickLeaveUser = (sick_leave_id, user_id) => {
  return core.API(
    "DELETE",
    `/sick-leave/${sick_leave_id}/user/${user_id}`,
    types.DELETE_SICK_LEAVE_USER,
    types.DELETE_SICK_LEAVE_USER_SUCCESS,
    types.DELETE_SICK_LEAVE_USER_FAILURE
  );
};
